/**
 * A location as a comparable number with 3-decimal precision, or null when it is blank or unparseable.
 * Safely handles null, undefined, empty string, and NaN.
 */
export function roundedLocation(value: any): number | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const numeric = Number(value);
  return Number.isNaN(numeric) ? null : Number(numeric.toFixed(3));
}
